"use strict";

import $ from "jquery";

class TourMap
{
    constructor(container, geoJson, options) {
        // Required.
        if (container.length < 1 || geoJson.length < 1) {
            return;
        }

        if (('ontouchstart' in window) || window.DocumentTouch && document instanceof DocumentTouch) {
            this.dragging = false;
        }
        else {
            this.dragging = true;
        }

        this.map = L.map(container, options || {
            dragging: this.dragging,
            tap: false,
            scrollWheelZoom: false,
            keyboard: false,
            zoomSnap: 0.5
        });

        L.mapboxGL({
            style: "https://api.visitscotland.com/maps/vector/v1/vts/resources/styles"
        }).addTo(this.map);

        this.map.attributionControl.setPrefix();
        this.map.attributionControl.addAttribution('Contains OS data © Crown copyright and database rights 2021');

        // Load the markers via geoJson.
        this.markers = [];
        this.geoJson(geoJson);
    }

    geoJson(data) {
        if (! data.length) {
            return;
        }

        if (data.length > 1) {
            data.forEach((item) => {
                this.setMarker(item);
            });

            this.setBounds();
        }
        else {
            if (typeof data[0] !== 'undefined') {
                this.setMarker(data[0]);

                this.map.setView(new L.LatLng(
                    data[0].geometry.coordinates[0],
                    data[0].geometry.coordinates[1]),
                    10
                );
            }
        }
    }

    setMarker(data) {
        const div = document.createElement("div");
              div.className = "marker";
              div.textContent = data.properties.title;

        const marker = L.marker([data.geometry.coordinates[0], data.geometry.coordinates[1]], {
            title: data.properties.title,
            icon: L.divIcon({
                className: "tours-marker",
                iconSize: ["auto", 30],
                iconAnchor: [0, 40],
                html: `<div class='marker'><div class='marker-pin'></div>${data.properties.title}</div>`
            })
        }).addTo(this.map);

        this.markers.push(marker);
    }

    setBounds() {
        const group = new L.featureGroup(this.markers);
        this.map.fitBounds(group.getBounds().pad(0.1));
    }
}

export default TourMap;
